export default class TabNavigationHelper {
    private static _instance: TabNavigationHelper;
    static get instance() {
        return this._instance || (this._instance = new this());
    }
    public setGroupAtt(el: HTMLElement | null): void {
        if (el) {
            if (!el.hasAttribute('group')) {
                el.toggleAttribute('group');
            }
        }
    }
    public setFocusAtt(el: HTMLElement | null, order?: number): void {
        if (el) {
            if (!el.closest('.pdp-sticky_header_container'))
                el.setAttribute('focusable', '');

            if (typeof order === 'number') {
                el.setAttribute('order', order.toString());
            }
        }

    }
    public setModalAtt(el: HTMLElement | null): void {
        if (el) {
            el.setAttribute('group', '');
            el.setAttribute('modal', '');
        }
    }
    public handleKeyDown(event): void {
        // prevent page jump down on Space btn., click
        if (event.key === ' ') //'Space'
            event.preventDefault();
    }

    public setAttributesForElement(element: HTMLElement | null, attributes: string[], remove = false) {
        if (element) {
            attributes.map(attribute => {
                if (remove) {
                    if (element.hasAttribute(attribute)) {
                        element.toggleAttribute(attribute);
                    }
                }
                else {
                    if (!element.hasAttribute(attribute)) {
                        element.toggleAttribute(attribute);
                    }
                }

            })
        }
    }

    public toggleDisabledAtt(root: HTMLElement | null, isDisabled: boolean) {
        if (root) {
            if (isDisabled)
                root.setAttribute('disabled', '');
            else root.removeAttribute('disabled')
        }
    }

    public setFirstFocus(root: HTMLElement | null) {
        if (root) {
            const firstFocus = root.querySelectorAll('[focusable]')[0]
            globalThis.shell.tabNav.focus(firstFocus);
        }
    }

    public setVariantPanelAttributes(root: HTMLElement | null, isOpen: boolean | undefined) {
        if (root) {
            if (!root.hasAttribute('group'))
                root.setAttribute('group', '');
            if (!root.hasAttribute('modal'))
                root.setAttribute('modal', '');

            if (isOpen) {
                root.removeAttribute('disabled');
            }
            else {
                root.setAttribute('disabled', '');
            }
        }
    }
}
